'use strict';

import Swiper from 'swiper';
import { Pagination } from 'swiper/modules';

const SELECTOR = '.js-social-panel-gallery';

export function init() {
    const elements = document.querySelectorAll(SELECTOR);

    if (!elements.length) {
        return;
    }

    elements.forEach(element => {
        const slidesContainerSelector = element.querySelector('.swiper-container');

        let swiper = new Swiper(slidesContainerSelector, {
            init: false,
            modules: [
                Pagination,
            ],
            pagination: {
                el: ".swiper-pagination",
                clickable: true,
            },
        });

        swiper.init();

    });
}
